import { COLOR_MAP } from "../ColorNames"

export const DropDown = ({ height = '16', width = '16', stroke = COLOR_MAP.DARK_PURPLE }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.64645 6.31246C3.84171 6.1172 4.15829 6.1172 4.35355 6.31246L8 9.95891L11.6464 6.31246C11.8417 6.1172 12.1583 6.1172 12.3536 6.31246C12.5488 6.50772 12.5488 6.82431 12.3536 7.01957L8.35355 11.0196C8.15829 11.2148 7.84171 11.2148 7.64645 11.0196L3.64645 7.01957C3.45118 6.82431 3.45118 6.50772 3.64645 6.31246Z" fill={stroke} />
    </svg>
  )
}